import { useQuery } from 'react-query';
import axiosClient from 'http/axios-client';
import CollectionKeys from './molecules/collection-keys';

function HasAnswersHook(kits) {
  // create query string for request questionnaire answered.
  let questionnaireQuery = `${ CollectionKeys.CUSTOMER_QUESTIONNAIRE_ANSWERS }/has-answers?`;
  if (undefined !== kits && kits.length > 0) {
    kits.forEach((kit) => {
      questionnaireQuery = questionnaireQuery.concat(`serial=${ kit?.serial_number_id?.serial }&`);
    });
    // remove last "&"
    questionnaireQuery = questionnaireQuery.slice(0, -1);
  }

  // make the request
  const {
    data: hasAnswers,
    isLoading: hasAnswersIsLoading,
  } = useQuery([ 'questionnaire-has-answers', kits ], () => {
    return axiosClient.get(questionnaireQuery);
  },
  { enabled: !!kits });

  return { hasAnswers, hasAnswersIsLoading };
}

export default HasAnswersHook;
